module.exports = __webpack_public_path__ + "img/vip3.a77f5213.png";